export const CRMCustomers = [
  {
    id: 601,
    company: "Sri Lakshmi Super Market",
    primaryContact: "Ravi Kumar",
    designation: "Proprietor",
    primaryEmail: "srilakshmisupermarket@gmail.com",
    phone: "9849012345",
    active: true,
    groups: ["POS Software"],
    dateCreated: "05/04/2024 10:15:32",
    renewalDate: "05/04/2027",
    simCard: null,
    simCarrier: null,
  },
  {
    id: 602,
    company: "Green Valley School",
    primaryContact: "Sujatha Devi",
    designation: "Principal",
    primaryEmail: "principal@greenvalleyschool.edu.in",
    phone: "9701122334",
    active: true,
    groups: ["Biometric Device"],
    dateCreated: "12/06/2024 09:42:15",
    renewalDate: null,
    simCard: "8991101203456789012",
    simCarrier: "Airtel",
  },
  {
    id: 603,
    company: "Sai Diagnostics",
    primaryContact: "Dr. Kiran Kumar",
    designation: "Managing Director",
    primaryEmail: "info@saidiagnostics.com",
    phone: "9988776655",
    active: true,
    groups: ["Access Control"],
    dateCreated: "21/07/2024 16:25:48",
    renewalDate: "21/07/2026",
    simCard: null,
    simCarrier: null,
  },
  {
    id: 604,
    company: "RK Constructions",
    primaryContact: "Ramesh Krishna",
    designation: "Managing Partner",
    primaryEmail: "rkconstructions@gmail.com",
    phone: "9012345678",
    active: false,
    groups: ["RC Lite"],
    dateCreated: "02/09/2024 14:18:10",
    renewalDate: "02/09/2025",
    simCard: null,
    simCarrier: null,
  },
  {
    id: 605,
    company: "Sunrise Hospital",
    primaryContact: "Dr. Meena Reddy",
    designation: "Administrator",
    primaryEmail: "admin@sunrisehospital.in",
    phone: "+91 9876543210",
    active: true,
    groups: ["Biometric"],
    dateCreated: "18/10/2024 08:35:26",
    renewalDate: "18/10/2027",
    simCard: "8991109876543210123",
    simCarrier: "Jio",
  },
  {
    id: 606,
    company: "Annapurna Rice Traders",
    primaryContact: "Srinivas Rao",
    designation: "Owner",
    primaryEmail: "annapurnarice@gmail.com",
    phone: "9440011223",
    active: true,
    groups: ["Thermal Printer"],
    dateCreated: "08/11/2024 17:10:54",
    renewalDate: null,
    simCard: null,
    simCarrier: null,
  },
  {
    id: 607,
    company: "Vijaya Engineering Works",
    primaryContact: "Mahesh Babu",
    designation: "Operations Manager",
    primaryEmail: "mahesh@vijayaengg.com",
    phone: "9393939393",
    active: true,
    groups: ["Rollcall"],
    dateCreated: "03/12/2024 13:55:41",
    renewalDate: "03/12/2026",
    simCard: null,
    simCarrier: null,
  },
  {
    id: 608,
    company: "Blue Sky Technologies",
    primaryContact: "Nikhil Sharma",
    designation: "CEO",
    primaryEmail: "nikhil@blueskytech.in",
    phone: "9123456789",
    active: true,
    groups: ["RC Lite"],
    dateCreated: "14/01/2025 11:08:19",
    renewalDate: "14/01/2028",
    simCard: null,
    simCarrier: null,
  },
  {
    id: 609,
    company: "Royal Residency",
    primaryContact: "Ashok Kumar",
    designation: "General Manager",
    primaryEmail: "gm@royalresidency.in",
    phone: "9866123456",
    active: true,
    groups: ["Access Control"],
    dateCreated: "20/02/2025 15:47:02",
    renewalDate: "20/02/2027",
    simCard: "8991112233445566778",
    simCarrier: "Vi",
  },
  {
    id: 610,
    company: "Sri Venkateswara Medical Agencies",
    primaryContact: "Prasad Reddy",
    designation: "Partner",
    primaryEmail: "svmedicalagencies@gmail.com",
    phone: "9848123456",
    active: false,
    groups: ["POS Software"],
    dateCreated: "11/03/2025 12:20:36",
    renewalDate: "11/03/2026",
    simCard: null,
    simCarrier: null,
  },
];
